import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EvaluadosDto } from '../dto/evaluados-dto';
import { ListadoDocentesDto } from '../dto/listado-docentes-dto';

@Injectable({
  providedIn: 'root'
})
export class CursoService {

  url = `${environment.host}/api/matricula-curso`;

  constructor(
    private http: HttpClient
  ) { }

  obtenerCursos(): Observable<ListadoDocentesDto[]> {
    return this.http.get<ListadoDocentesDto[]>(`${this.url}/cursos-docentes`).pipe(catchError(error => {
      console.log('Error service MatriculaCurso-obtenerCursos', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }

  ObtenerEvaluados(tipo: number, periodo: number): Observable<EvaluadosDto[]> {
    return this.http.get<EvaluadosDto[]>(`${this.url}/evaluados/${tipo}/${periodo}`).pipe(catchError(error => {
      console.log('Error service MatriculaCurso-obtenerEvaluados', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }

  ObtenerDocentesEvaluados(tipo: number, periodo: number): Observable<EvaluadosDto[]> {
    return this.http.get<EvaluadosDto[]>(`${this.url}/evaluadosDocentes/${tipo}/${periodo}`);
  }

  public validarEvaluacion(evaluador: String, docente: number, periodo: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.url}/validarEvaluacion/${evaluador}/${docente}/${periodo}`).pipe(catchError(error => {
      console.log('Error service MatriculaCurso-validarEvaluacion', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }
}
